import { render, staticRenderFns } from "./edit-endorsement.vue?vue&type=template&id=bceb946a&scoped=true&"
import script from "./edit-endorsement.vue?vue&type=script&lang=js&"
export * from "./edit-endorsement.vue?vue&type=script&lang=js&"
import style0 from "./edit-endorsement.vue?vue&type=style&index=0&id=bceb946a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bceb946a",
  null
  
)

export default component.exports